"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { GlobalData } from "./context/GlobalContext";

export default function GlobalLoader() {
    const { pageLoader, setPageLoader } = GlobalData()
    const pathname = usePathname();
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!pathname) return;

        // Start loader
        setPageLoader(true);

        // Simulate loading until page finishes hydrating
        const timer = setTimeout(() => {
            setPageLoader(false);
        }, 600); // adjust duration if needed

        return () => clearTimeout(timer);
    }, [pathname]);

    return (
        <div
            className={`fixed top-[56px] left-0 h-[3px] bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-500 z-[9999] ${pageLoader ? "w-full opacity-100" : "w-0 opacity-0"
                }`}
        />
    );
}
